import styled from "styled-components";

export const Title = styled.h2`
  font-size: var(--fz-heading);
  font-weight: 700;
  margin-bottom: 20px;
  color: var(--teal);
`;

export const CategoryTabs = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  background-color: var(--teal-20);
  border-radius: 10px;
  margin-bottom: 20px;
`;

export const Tab = styled.button`
  background-color: ${(props) =>
    props.$active ? "var(--teal-20)" : "transparent"};
  color: var(--rose-80);
  border: none;
  padding: 15px 25px;
  cursor: pointer;
  font-size: var(--fz-lg);
  font-weight: 400;
  flex: 1;
  min-width: 120px;
  border-radius: 10px;
  text-align: center;
  border-bottom: 4px solid
    ${(props) => (props.$active ? "var(--teal-20)" : "transparent")};
  transition:
    background-color 0.3s ease,
    border-bottom 0.3s ease;

  &:hover {
    background-color: var(--teal-20);
  }
`;

export const ProjectsSection = styled.section`
  position: relative;
  contain: layout style;
  min-height: 600px;
  margin: 0 auto;
  padding: 100px;
  text-align: center;
  color: rgba(240, 216, 221, 0.9);
  overflow: hidden;

  @media (max-width: 1080px) {
    padding: 50px 10px;
  }
  @media (max-width: 768px) {
    padding: 50px;
  }
  @media (max-width: 480px) {
    padding: 50px 20px;
  }
`;

export const ContentWrapper = styled.div`
  min-height: 500px;
  position: relative;
  overflow: hidden;
  contain: layout;
`;
